// 发音人语种
export const  FOREIGN  = [
    '英文','英语','德文','德语','俄语','俄文','法语','法文','韩语','韩文','日语','日文','西班牙语',
    '西班牙文','印尼语','印尼文','意大利语','意大利文','葡萄牙语','葡萄牙文','菲律宾语','菲律宾文','越南语','越南文','荷兰语','荷兰文','泰语',
    '泰文','南非','南非语','南非文'
  ]
// 智能文案数字对应
export const BRAIN_TYPE_ID = {
  1: 'TITLE',
  2: 'DESC',
  3: 'CITATION',
  4: 'REWRITE',
  5: 'TEXT_IMG',
  6: 'CONVER_IMG'
}

// 智能文案工具类型
export const BRAIN_TYPE_TEXT = {
  'TITLE': '智能标题',
  'DESC': '智能描述',
  'CITATION': '黄金开场',
  'REWRITE': '智能改写',
  'TEXT_IMG': '文生图',
  'CONVER_IMG': '智能生图'
}